var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"avatar-container"},[_c('img',{staticClass:"avatar-img",style:({
        width: _vm.width + 'px',
        height: _vm.height + 'px'
    }),attrs:{"src":_vm.url}})])
}
var staticRenderFns = []

export { render, staticRenderFns }